import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { range, TIMEPICKER_FORMAT } from 'utils/helpers/dateHelper'

dayjs.extend(customParseFormat)

const INTERVALS = ['00', '15', '30', '45']

export const makeIntervalsArray = ({
  startMoment,
  blockBefore,
  assumeMidnight
}) => {
  const hours = range(0, 24)
  const times = []
  let newStartMoment = startMoment ? startMoment.clone() : dayjs()
  const isToday = newStartMoment.isSame(dayjs(), 'day')

  if (assumeMidnight) {
    if (isToday) {
      newStartMoment = dayjs()
    } else {
      newStartMoment = newStartMoment.hour(0).minute(0).second(0)
    }
  }

  hours.forEach(hour =>
    INTERVALS.forEach(minute => {
      const timeLabel = dayjs()
        .hour(hour)
        .minute(minute)
        .format(TIMEPICKER_FORMAT)

      const newDate = newStartMoment.clone().hour(hour).minute(minute)

      const isDisabled =
        !newStartMoment?.isValid() ||
        (blockBefore && newDate.isBefore(newStartMoment))

      times.push({
        label: timeLabel,
        value: timeLabel,
        disabled: isDisabled
      })
    })
  )

  return times
}
